import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex, Text, Link, NakedButton } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

export const AuthButton = styled(NakedButton)`
  display: flex;
  cursor: pointer;
  height: 74px;
  min-width: ${(props) => (props.isAuthenticated ? '300px' : '92px')};
  padding: ${themeGet('space.4')} 0;
  background-color: ${themeGet('colors.brand.primary')};
  color: ${themeGet('colors.white')};
  align-items: center;
  justify-content: center;
  border-radius: ${(props) => (props.isOpen ? 'null' : themeGet('radii.defaultRoundBottomOnly'))};
`;

export const QffMenuWrapper = styled(Flex)`
  width: 300px;
  z-index: ${themeGet('zIndices.phoneMenuDrawerClose')};
  position: absolute;
  flex-direction: column;
  transition: all 0.2s ease-in-out;
  background-color: ${themeGet('colors.white')};
  box-shadow: ${themeGet('shadows.soft')};
`;

export const MembershipTier = styled(Text)`
  font-size: ${themeGet('fontSizes.sm')};
  font-weight: ${themeGet('fontWeights.bold')};
`;

export const AccountLink = styled(Link)`
  color: ${themeGet('colors.white')};
  &:hover {
    color: ${themeGet('colors.white')};
  }

  ${mediaQuery.minWidth.md} {
    color: ${themeGet('colors.greys.charcoal')};
    &:hover {
      color: ${themeGet('colors.greys.charcoal')};
    }
  }
`;

export const StyledText = styled(Text)`
  font-size: ${themeGet('fontSizes.sm')};
  font-weight: bold;
`;

export const JoinLink = styled(Link)`
  color: ${themeGet('colors.white')};
  &:hover {
    color: ${themeGet('colors.white')};
  }
`;

export const HoveredText = styled(Text)`
  &:hover {
    color: ${themeGet('colors.brand.primary')};
  }
`;
